var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderBlob2 = function SvgHeaderBlob2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 811,
    height: 729,
    viewBox: "0 0 611 629",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.558 59.1226C365.376 71.1021 396.045 80.7769 428.279 88.1441C467.715 97.1572 513.258 84.8836 546.721 107.613C579.912 130.157 598.477 170.858 607.583 209.935C616.514 248.267 600.234 287.025 597.677 326.301C595.025 367.055 616.696 414.73 592.129 447.355C566.626 481.22 505.659 462.374 473.987 490.555C437.49 523.03 444.634 592.394 402.106 616.436C362.988 638.55 308.448 628.15 269.153 606.352C229.607 584.415 222.882 528.837 189.398 498.441C160.226 471.961 117.118 467.199 87.384 441.352C52.1411 410.715 -0.924464 380.496 0.0122329 333.808C1.00192 284.479 78.1708 267.19 91.8293 219.779C106.178 169.973 53.7975 113.072 76.9613 66.7052C98.2517 24.0882 153.989 1.43733 201.608 0.0356173C250.618 -1.40708 288.857 41.3584 334.558 59.1226Z",
    fill: "#582BEE",
    fillOpacity: 0.08
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderBlob2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header_blob_2.dc53739c.svg";
export { ForwardRef as ReactComponent };